<template>
  <div>
    <p>{{ IL }} / {{ ILCE }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      IL: "",
      ILCE: "",
    };
  },
  methods: {
    gelenData() {
      this.IL = this.params.data.CITY;
      this.ILCE = this.params.data.TOWN;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
